"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSubNavCommand = void 0;
const audiences_1 = require("@cfc/audiences");
class GetSubNavCommand {
    constructor(endpoint, input) {
        this.endpoint = endpoint;
        this.input = input;
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            this.validate();
            const response = yield fetch(`${this.endpoint}/api/v1/subnav?${this.getQueryParams()}`);
            if (!response.ok) {
                throw new Error(`Failed to get subnav data: ${response.status} ${response.statusText}`);
            }
            const data = yield response.json();
            return data;
        });
    }
    getQueryParams() {
        const { app, route, userContext } = this.input;
        const queryParams = new URLSearchParams({
            app
        });
        if (userContext) {
            // base64 encode the user context:
            queryParams.append('userContext', (0, audiences_1.encodeUserContext)(userContext));
        }
        if (route) {
            queryParams.append('route', route);
        }
        return queryParams;
    }
    validate() {
        if (!this.input.app) {
            throw new Error('please provide a valid app');
        }
    }
}
exports.GetSubNavCommand = GetSubNavCommand;
